import { m } from "@/paraglide/messages";

export interface SipExplainerProps {
  howTo: string;
  faqs: Array<{ q: string; a: string }>;
}

/** How-to + FAQ block. The matching FAQPage JSON-LD is emitted by the route. */
export function SipExplainer({ howTo, faqs }: SipExplainerProps) {
  return (
    <div className="mt-12 space-y-10">
      <section className="space-y-3">
        <h2 className="font-display text-2xl font-bold tracking-tight">
          {m.sip_howto_title()}
        </h2>
        <p className="whitespace-pre-line leading-relaxed text-muted-foreground">
          {howTo}
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-2xl font-bold tracking-tight">
          {m.sip_faq_title()}
        </h2>
        <dl className="space-y-3">
          {faqs.map((f) => (
            <div
              key={f.q}
              className="rounded-xl border border-border bg-card/40 p-4"
            >
              <dt className="font-semibold text-foreground">{f.q}</dt>
              <dd className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                {f.a}
              </dd>
            </div>
          ))}
        </dl>
      </section>
    </div>
  );
}
